import { Allocation } from "src/models/AllocationReviewAndSend";
import { PriorityAllocationSessionStatus } from "src/models/AllocationV2";
import { create } from "zustand";

interface PriorityAllocationStore {
  priorityAllocFullSessions: Record<number, PriorityAllocationSessionStatus>;
  priorityAllocations: Allocation[];
  setPriorityAllocFullSessions: (sessions: Record<number, PriorityAllocationSessionStatus>) => void;
  setPriorityAllocations: (allocations: Allocation[]) => void;
  isSessionPriorityActiveAndNotFull: (sessionId: number) => boolean;
  getAvailablePrioritySeats: (sessionId: number) => number | undefined;
  updatePriorityAllocFullSession: (sessionId: number, status: PriorityAllocationSessionStatus) => void;
  clearPriorityAllocFullSessions: () => void;
  clearPriorityAllocations: () => void;
}

export const usePriorityAllocationStore = create<PriorityAllocationStore>(
  (set, get) => ({
    priorityAllocFullSessions: {},
    priorityAllocations: [],
    setPriorityAllocFullSessions: (sessions) =>
      set({ priorityAllocFullSessions: sessions }),
    setPriorityAllocations: (allocations) =>
      set({ priorityAllocations: allocations }),
    isSessionPriorityActiveAndNotFull: (sessionId) => {
        const status = get().priorityAllocFullSessions[sessionId]
        return ( typeof status !== "undefined" && status.isFull === false)
    },
    getAvailablePrioritySeats: (sessionId) => {
        const status = get().priorityAllocFullSessions[sessionId]
        return status?.availableSeats;
    },
    updatePriorityAllocFullSession: (sessionId, status) =>
      set((state) => ({
        priorityAllocFullSessions: {
          ...state.priorityAllocFullSessions,
          [sessionId]: status,
        },
      })),
    clearPriorityAllocFullSessions: () => set({ priorityAllocFullSessions: {} }),
    clearPriorityAllocations: () => set({ priorityAllocations: [] }),
  })
);
